// noinspection ExceptionCaughtLocallyJS

import * as constants from '../constants';
import { ACTION, setLoading, wrap } from './index';
import { store } from '../index';
import { Dispatch } from 'redux';
import {
  SchemaAddToBasketRequestBody,
  SchemaBasketInfo,
  SchemaBasketInfoResponse,
  SchemaCopyBasketRequestBody,
  SchemaCreateNewBasketRequestBody,
  SchemaDeleteBasketQueryParams,
  SchemaEditBasketEntryRequestBody,
  SchemaGetBasketContentQueryParams,
  SchemaGetBasketDefinitionQueryParams,
  SchemaGetBasketInfoQueryParams,
  SchemaPostBasketRequestBody,
  SchemaRemoveFromBasketRequestBody,
  SchemaUnlockBasketRequestBody,
} from '@repo/legacy-commerce-api';
import legacyApi from '../middlewares/api';

export const openBasket = () => ({ type: constants.OPEN_BASKET });
export const closeBasket = () => ({ type: constants.CLOSE_BASKET });

export const deleteBasket = (payload: SchemaDeleteBasketQueryParams) =>
  wrap(async (dispatch: Dispatch) => {
    try {
      dispatch(setLoading(true));
      const { data, error } = await legacyApi.DELETE('/basketdelete', { params: { query: payload } });

      if (error) {
        throw JSON.stringify(error);
      }

      return data;
    } catch (err) {
      console.error('error: ', err);
      dispatch(setLoading(false));
      throw err;
    } finally {
      dispatch(setLoading(false));
    }
  }, constants.FETCH_ERROR);

export const chooseBasket = (payload: any): ACTION => ({
  type: constants.CHOOSE_BASKET,
  payload,
});

// unused:
export const addToBasketByProductId = (productId: string) => {
  const addToNewBasket = async (productId: string, dispatch?: Dispatch) => {
    const storeObj = store.getState();
    const payload: SchemaAddToBasketRequestBody = {
      startdate: storeObj.app.userDataEC.startDate,
      duration: storeObj.app.userDataEC.duration,
      basketreference: storeObj.app.userDataEC.basketInfo.basketreference,
      basket: storeObj.app.userDataEC.basketInfo.basket,
      autocorrectstartdate: 1,
      producturns: [productId],
    };

    try {
      dispatch(setLoading(true));
      const { data, error } = await legacyApi.POST('/addtobasket', { body: payload });

      if (error) {
        throw JSON.stringify(error);
      }

      return data;
    } catch (err) {
      console.error('error: ', err);
      dispatch(setLoading(false));
      throw err;
    } finally {
      dispatch(setLoading(false));
    }
  };

  return wrap(async (dispatch: Dispatch) => {
    const storeObj = store.getState();
    if (storeObj.app.userDataEC.basketInfo && storeObj.app.userDataEC.basketInfo.basket) {
      return addToNewBasket(productId, dispatch);
    } else {
      try {
        const payload: SchemaCreateNewBasketRequestBody = {
          // 0 = favorite list,
          // 1 = order list
          // 2 = offer list
          category: 1,
          industry: storeObj.app.userDataEC.bigIndustry || storeObj.app.userDataEC.industry,
          name: 'testBasket',
        };
        dispatch(setLoading(true));
        const { data, error } = await legacyApi.POST('/newbasket', { body: payload });

        if (error) {
          throw JSON.stringify(error);
        }

        dispatch({ type: constants.CREATED_BASKET, payload: data });
        await addToNewBasket(productId, dispatch);
      } catch (err) {
        console.error('error: ', err);
        dispatch(setLoading(false));
        throw err;
      }
    }
  }, 'POST_ERROR');
};

export const addToBasket = (payload: SchemaAddToBasketRequestBody) =>
  wrap(async (dispatch: Dispatch) => {
    try {
      dispatch(setLoading(true));
      const { data, error } = await legacyApi.POST('/addtobasket', { body: payload });

      if (error) {
        throw JSON.stringify(error);
      }

      dispatch({ type: constants.ADDED_TO_BASKET, payload: data });
      return data;
    } catch (err) {
      console.error('error: ', err);
      dispatch(setLoading(false));
      throw err;
    }
  }, 'POST_ERROR');

export const editInBasket = (payload: SchemaEditBasketEntryRequestBody) =>
  wrap(async (dispatch: Dispatch) => {
    try {
      dispatch(setLoading(true));
      const { data, error } = await legacyApi.PATCH('/basketentry', { body: payload });

      if (error) {
        throw JSON.stringify(error);
      }

      return data;
    } catch (err) {
      console.error('error: ', err);
      dispatch(setLoading(false));
      throw err;
    } finally {
      dispatch(setLoading(false));
    }
  }, 'POST_ERROR');

export const removeFromBasket = (payload: SchemaRemoveFromBasketRequestBody, _urn: string) =>
  wrap(async (dispatch: Dispatch) => {
    try {
      const storeObj = store.getState();
      const basket = storeObj.app.userDataEC.basketInfo.basket;
      dispatch(setLoading(true));

      const { data, error } = await legacyApi.POST('/removefrombasket', { body: { entries: payload.entries, basket } });

      if (error) {
        throw JSON.stringify(error);
      }

      return data;
    } catch (err) {
      console.error('error: ', err);
      dispatch(setLoading(false));
      throw err;
    } finally {
      dispatch(setLoading(false));
    }
  }, 'POST_ERROR');

// ToDo: deal with two removeFromBasket actions
export const removeFromBasketByPayload = (payload: SchemaRemoveFromBasketRequestBody, urn: string) =>
  wrap(async (dispatch: Dispatch) => {
    try {
      dispatch(setLoading(true));
      const { data, error } = await legacyApi.POST('/removefrombasket', { body: payload });

      if (error) {
        throw JSON.stringify(error);
      }

      dispatch({
        type: constants.REMOVED_FROM_BASKET,
        payload: { ...data, urn },
      });
      return data;
    } catch (err) {
      console.error('error: ', err);
      dispatch(setLoading(false));
      throw err;
    }
  }, 'POST_ERROR');

export const createBasket = (payload: SchemaCreateNewBasketRequestBody) =>
  wrap(async (dispatch: Dispatch) => {
    try {
      dispatch(setLoading(true));

      const { data, error } = await legacyApi.POST('/newbasket', { body: payload });

      if (error) {
        throw JSON.stringify(error);
      }

      dispatch({ type: constants.CREATED_BASKET, payload: data });
      return data;
    } catch (err) {
      console.error('error: ', err);
      dispatch(setLoading(false));
      throw err;
    }
  }, 'POST_ERROR');

export const clearBasketInfo = () => ({ type: constants.CLEAR_BASKET_INFO });

export const fetchBasketInfo = (
  params: SchemaGetBasketInfoQueryParams,
  oldBasketInfo?: SchemaBasketInfo,
  isSkipUpdateStore?: boolean,
) =>
  wrap(async (dispatch: Dispatch) => {
    try {
      dispatch(
        setLoading({
          value: true,
          name: 'basket',
        }),
      );
      if (params.basketreference === null) {
        delete params.basketreference;
      }

      const { data, error } = await legacyApi.GET('/basketinfo', { params: { query: params } });

      if (error) {
        throw JSON.stringify(error);
      }

      if (!isSkipUpdateStore) {
        dispatch({
          type: constants.FETCHED_BASKET_INFO,
          payload: {
            ...data,
            oldBasketInfo: oldBasketInfo,
          },
        });

        const normalizeBasketInfo = (data: SchemaBasketInfoResponse): SchemaBasketInfo => {
          return Array.isArray(data.data) ? data.data[0] : data.data;
        };

        const newBasketInfo = normalizeBasketInfo(data);

        if (newBasketInfo.voucher && newBasketInfo.voucher.codes) {
          if (newBasketInfo.voucher.codes.length > 0) {
            const voucherObject = {
              basket: newBasketInfo.basket,
              code: newBasketInfo.voucher.codes[0],
            };
            // Problem: there is not "SET_VOUCHER" currently so we delete and add ...
            dispatch({ type: constants.DELETED_VOUCHER, payload: [] });
            dispatch({
              type: constants.ADDED_VOUCHER,
              payload: [],
              posted: voucherObject,
            });
          } else {
            dispatch({ type: constants.DELETED_VOUCHER, payload: [] });
          }
        }
      }
      return data.data;
    } catch (err) {
      console.log('error: ', err);
      dispatch(
        setLoading({
          value: false,
          name: 'basket',
        }),
      );
      throw err;
    } finally {
      dispatch(
        setLoading({
          value: false,
          name: 'basket',
        }),
      );
    }
  }, constants.FETCH_ERROR);

export const fetchBookedBasketInfo = (params: SchemaGetBasketInfoQueryParams) =>
  wrap(async (dispatch: Dispatch) => {
    try {
      dispatch(
        setLoading({
          value: true,
          name: 'basket',
        }),
      );
      if (params.basketreference === null) {
        delete params.basketreference;
      }

      const { data, error } = await legacyApi.GET('/basketinfo', { params: { query: params } });

      if (error) {
        throw JSON.stringify(error);
      }

      dispatch({
        type: constants.FETCHED_LAST_BOOKED_BASKET_INFO,
        payload: {
          ...data,
        },
      });
      return data.data;
    } catch (err) {
      console.log('error: ', err);
      dispatch(
        setLoading({
          value: false,
          name: 'basket',
        }),
      );
      throw err;
    } finally {
      dispatch(
        setLoading({
          value: false,
          name: 'basket',
        }),
      );
    }
  }, constants.FETCH_ERROR);

export const getBasketContent = (params: SchemaGetBasketContentQueryParams) =>
  wrap(async (dispatch: Dispatch) => {
    try {
      dispatch(setLoading(true));

      // Wenn processstate 1 oder "open", wird ein Ergebnis nur zurückgegeben, wenn ein bearbeitbarer WArenkorb vorhanden
      // ist, sonst ein Fehler. Der Fehler muss dann bearbeitet werden
      const parameters: SchemaGetBasketContentQueryParams = {
        basket: params.basket ?? null,
        basketreference: params.basketreference ?? null,
        group: 'producttype,city,format',
        processstate: params.processstate ?? null,
      };

      const { data, error } = await legacyApi.GET('/basketcontent', { params: { query: parameters } });

      if (error) {
        throw JSON.stringify(error);
      }

      dispatch({
        type: constants.FETCHED_BASKETJ2,
        payload: { ...data, basket: params.basket },
      });
      return data.data;
    } catch (err) {
      console.error('error: ', err);
      dispatch(setLoading(false));
      throw err;
    } finally {
      dispatch(setLoading(false));
    }
  }, constants.FETCH_ERROR);

export const getBasketDefinition = (params: SchemaGetBasketDefinitionQueryParams) =>
  wrap(async (dispatch: Dispatch) => {
    try {
      dispatch(setLoading(true));

      if (params.basketreference === null) {
        delete params.basketreference;
      }

      const { data, error } = await legacyApi.GET('/basketdefinition', { params: { query: params } });

      if (error) {
        throw JSON.stringify(error);
      }

      dispatch({
        type: constants.FETCHED_BASKET_DEFINITION,
        payload: { ...data, basket: params.basket },
      });
      return data.data;
    } catch (err) {
      console.error('error: ', err);
      dispatch(setLoading(false));
      throw err;
    } finally {
      dispatch(setLoading(false));
    }
  }, constants.FETCH_ERROR);

export const copyBasket = (payload: SchemaCopyBasketRequestBody) =>
  wrap(async (dispatch: Dispatch) => {
    try {
      dispatch(setLoading(true));
      const { data, error } = await legacyApi.POST('/copybasket', { body: payload });

      if (error) {
        throw JSON.stringify(error);
      }

      dispatch({ type: constants.COPIED_BASKET_J3, payload: data });
      return data;
    } catch (err) {
      console.error('error: ', err);
      dispatch(setLoading(false));
      throw err;
    }
  }, 'POST_ERROR');

export const unlockBasket = (payload: SchemaUnlockBasketRequestBody) =>
  wrap(async (dispatch: Dispatch) => {
    try {
      dispatch(setLoading(true));

      // TODO: APG-129 we should be sending query params and a body here
      const { data, error } = await legacyApi.POST('/basketunlock', { body: payload, params: { query: payload } });

      if (error) {
        throw JSON.stringify(error);
      }

      dispatch({ type: constants.COPIED_BASKET_J3, payload: data });
      return data;
    } catch (err) {
      console.log('error: ', err);
      dispatch(setLoading(false));
      throw err;
    }
  }, 'POST_ERROR');

export const postBasketData = (payload: SchemaPostBasketRequestBody) =>
  wrap(async (dispatch: Dispatch) => {
    try {
      dispatch(setLoading(true));
      if (payload.basketreference === null) {
        delete payload.basketreference;
      }

      const { data, error } = await legacyApi.POST('/basketdata', { body: payload });

      if (error) {
        throw JSON.stringify(error);
      }

      dispatch({
        type: constants.BASKET_DATA_POSTED,
        payload: { ...data, basket: payload.basket },
      });

      return data;
    } catch (err) {
      console.error('error: ', err);
      dispatch(setLoading(false));
      throw err;
    } finally {
      dispatch(setLoading(false));
    }
  }, 'POST_ERROR');
